import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=2c9fc1c4&scoped=true&"
import script from "./TextAreaInput.vue?vue&type=script&lang=ts&"
export * from "./TextAreaInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=2c9fc1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9fc1c4",
  null
  
)

export default component.exports